import aceModeDefs from '~/scripts/constants/ace';
import FileUpload from '~/scripts/services/model/file-upload';
import APIV5 from '~/models/api';
import PdfUtils from '~/components/pdf/pdf-utils';
import { getType, getRender } from '~/scripts/constants/mime';
import Defaults from '~/scripts/constants/defaults';
import angular from 'angular';
import DOMPurify from 'dompurify';

/* globals Knitiv */

export default class KformTabFileController {
	#$injector;

	#$rootScope;

	#$scope;

	#$timeout;

	#$translate;

	#FileDownloadService;

	#FormService;

	#NodeService;

	#Notification;

	/**
	 *
	 * @param {import('angular').auto.IInjectorService} $injector
@param {Knitiv.RootScope} $rootScope	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} FileDownloadService
	 * @param {import('~/scripts/services/form.service').default} FormService
	 * @param {any} NodeService
	 * @param {any} Notification
	 * @param {any} User
	 * @param {import('angular').ISCEService} $sce
	 */
	/* @ngInject */
	constructor(
		$injector,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		FileDownloadService,
		FormService,
		NodeService,
		Notification,
		User,
		$sce,
	) {
		this.#$injector = $injector;
		this.#$rootScope = $rootScope;
		this.#$scope = $scope;
		this.#$timeout = $timeout;
		this.#$translate = $translate;
		this.#FileDownloadService = FileDownloadService;
		this.#FormService = FormService;
		this.#NodeService = NodeService;
		this.#Notification = Notification;
		this.$sce = $sce;

		this.Defaults = Defaults;

		this.pdfUtils = new PdfUtils($injector);

		this.content = undefined;
		this.disabled = undefined;

		/** @type {any} */
		this.infos = undefined;

		/** @type {?import('~/components/kform/kform.controller').default} */
		this.kform = null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		/** @type {import('~/scripts/services/model/file-upload').default | undefined} */
		this.file = undefined;

		this.htmlPreviewInitializing = undefined;

		/** @type {boolean} */
		this.replacing = false;

		/** @type {boolean} */
		this.isAdmin = !!User.getProfil().admin;

		this.jsonEditorDefaultOptions = {
			readOnly: {
				mode: 'view',
				modes: [
					'view',
				],
			},
			edit: {
				mode: 'tree',
				modes: [
					'tree',
					'view',
					'form',
					'code',
					'text',
				],
			},
		};
		this.jsonEditorOptions = {};
		this.kid = null;
		this.loading = true;

		/** @type {?Function} */
		this.onLoad = null;
	}

	/**
	 * Switches to the full upload interface instead of opening the file picker directly
	 */
	startReplace() {
		this.replacing = true;
	}

	/**
	 * Set node file to html viewer in order to open the RTF editor
	 */
	createFileHTML() {
		this.replacing = false;
		if (!this.file?.file) {
			this.htmlPreviewInitializing = false;
		}
		// if (!(this.kid in this.kform.files) || !this.files[this.currentClassForm]) {
		// 	this.files[this.currentClassForm] = new FileUpload(this.#$injector);
		// }
		if (this.file) {
			this.file.loaded = this.file.file.size;
		}
		if (this.form) {
			this.form.isfile = true;
			this.form.viewer_engine = 'html';
		}
	}

	/**
	 * Removes a file from the specified form
	 */
	async detachFile() {
		if (this.form && this.file) {
			await this.kform?.detachFile(this.form, this.file);
		}
	}

	/**
	 * Downloads the file of the current form
	 */
	download() {
		if (this.form?.checkDroit(Defaults.DROIT.READ)) {
			this.#FileDownloadService
				.download([{ kid: this.kid }])
				.catch((/** @type {any} */ error) => {
					console.error(error);
				});
		}
	}

	/**
	 * @param {string} source
	 * @returns {Promise<any>}
	 */
	trustSrc(source) {
		return this.$sce.trustAsResourceUrl(source);
	}

	/**
	 * Loads the file for preview it
	 *
	 * @returns {Promise<any>} Promise result
	 */
	async loadFile() {
		if (
			this.kid
			&& this.form
			&& this.form.isfile
			&& this.file
			&& !this.file.loaded
			&& this.file.file
		) {
			// fetch viewer and if no viewer, fallback to original
			if (this.#$rootScope.kds) {
				const infosMultiple = await APIV5.instance.fileInfoMultiple(
					{
						nodeid: this.kid,
						type:   'viewer',
					},
					{
						id: 'kform-tab-file.load-file',
					},
				);
				if (infosMultiple.files.length > 0) {
					this.infos = {
						nodeid: infosMultiple.nodeid,
						type:   infosMultiple.type,
						...infosMultiple.files[0],
					};
				}
			}
			else {
				this.infos = await APIV5.instance.fileInfo(
					{
						nodeid: this.kid,
						type:   'viewer',
					},
					{
						id:              'kform-tab-file.load-file',
					},
				);
			}

			const viewer = getType(this.infos.mimetype);
			const render = getRender(viewer);

			if (viewer !== 'binary') {
				this.form.viewer_engine = viewer;
			}
			// if (!this.form?.viewer_mimetype) {
			// 	this.form.viewer_mimetype = this.infos.mimetype;
			// }

			let url;
			let data;

			/** @type {import('@knitiv/api-client-javascript').DownloadInput} */
			const downloadRequest = {
				inline: true,
				mode:   'chunked',
				nodeid: this.kid,
				type:   'viewer',
			};
			const options = {
				endpointVersion: this.#$rootScope.kds ? 3 : 2,
			};

			switch (render) {
			case 'inline': {
				url = APIV5.instance.downloadURL(downloadRequest, options);
				break;
			}
			case 'custom': {
				const dl = await APIV5.instance.download(downloadRequest, options);
				data = dl.buffer;
				url = URL.createObjectURL(new Blob([data], { type: this.infos.mimetype }));
				break;
			}
			case 'none': {
				this.file.loaded = this.infos.size;
				break;
			}
			default: {
				url = null;
			}
			}

			if (url) {
				const r = /\.([^.])+$/.exec(this.infos.name);
				let extension = null;

				switch (viewer) {
				case 'mail': {
					this.file.url = data;
					break;
				}

				case 'pdf': {
					this.file.url = this.trustSrc(url);
					this.file.kid = this.kid;
					break;
				}

				case 'zip': {
					this.file.loaded = this.infos.size;
					try {
						this.file.url = JSON.parse(new TextDecoder('utf8').decode(data));
					}
					catch (error) {
						console.error(error);
						this.form.viewer_engine = null;
					}
					break;
				}

				case 'json': {
					try {
						this.file.url = JSON.parse(new TextDecoder('utf8').decode(data));
					}
					catch (error) {
						console.error(error);
						this.form.viewer_engine = null;
					}
					break;
				}

				case 'text': {
					try {
						this.file.url = new TextDecoder('utf8').decode(data);
					}
					catch (error) {
						console.error(error);
						this.form.viewer_engine = null;
					}

					if (r && r[1]) {
						extension = r[1];
					}

					for (const definition of Object.values(aceModeDefs)) {
						if ('mimetypes' in definition && Array.isArray(definition.mimetypes)) {
							for (const mimetype of definition.mimetypes) {
								if (mimetype === this.file.file.type) {
									// TODO: Set correct text mode using a compartment for language
								}
							}
						}
						if (extension && 'ext' in definition && Array.isArray(definition.ext)) {
							for (const definitionExtension of definition.ext) {
								if (definitionExtension === extension) {
									// TODO: Set correct text mode
								}
							}
						}
					}
					if (this.file.file.type === 'text/html') {
						// TODO: Set correct text mode
					}
					break;
				}

				case 'html': {
					const content = new TextDecoder('utf8').decode(data);
					this.file.url = DOMPurify.sanitize(content);
					this.kform?.renderFileAsHTML(this.file.url);
					break;
				}

				case 'image': {
					this.file.url = {
						rotate: 0,
						url:    this.trustSrc(url),
					};
					break;
				}

				case 'video': {
					this.file.url = this.trustSrc(url);
					break;
				}

				default: {
					this.form.viewer_engine = null;
				}
				}

				if (viewer === 'pdf' && url) {
					const resultPromise = await fetch(url);
					const pdf = await resultPromise.arrayBuffer();
					this.file.signatures = this.pdfUtils.getSignatures(pdf);
				}

				this.#$timeout(() => {
					if (this.file) {
						this.file.loaded = this.infos.size;
					}
				});
				if (this.kform?.backupFiles) {
					this.kform?.backupFiles(this.kid);
				}
				if (typeof this.onLoad === 'function') {
					this.onLoad();
				}
			}
		}
	}

	/**
	 * @param {Event} event
	 */
	onDocumentAsFileChanged(event) {
		let value;

		switch (this.form?.viewer_engine) {
		case 'json': {
			if (this.file && this.file.url !== event) {
				this.file.file = new File(
					[JSON.stringify(this.file.url)],
					this.file.name || `${this.#$translate.instant('common.unnamed-doc')}.json`,
					{ type: 'application/json' },
				);
				this.form.formio?.kformForm.$setDirty();
			}
			break;
		}

		case 'html': {
			if (this.file && !this.htmlPreviewInitializing) {
				value = `<!doctype html>
<html lang="en">
<head><meta charset="utf-8"><title></title></head>
<body>${this.file.url}</body></html>`;
				this.file.file = new File(
					[value],
					this.file.name || `${this.#$translate.instant('common.unnamed-doc')}.html`,
					{ type: 'text/html' },
				);
				this.form.formio?.kformForm.$setDirty();
			}
			break;
		}

		default: {
			if (this.file && this.file.url !== event) {
				this.file.file = new File(
					[this.file.url],
					this.file.name || `${this.#$translate.instant('common.unnamed-doc')}.txt`,
					{ type: 'text/plain' },
				);
				this.form?.formio?.kformForm.$setDirty();
			}
			break;
		}
		}

		if (this.file?.file) {
			this.file.name = this.file.file.name;
		}
	}

	openSignatures() {
		this.pdfUtils.showModalSignatures(this.file?.signatures);
	}

	/**
	 * Prints the current form
	 */
	// eslint-disable-next-line class-methods-use-this
	print() {
		const divContents = angular.element('body');

		divContents.addClass('print-html');
		window.print();
		divContents.removeClass('print-html');
	}

	async relaunchKonvProcess() {
		const node = await this.#NodeService.load(this.form?.kid);
		const attribut = node.attribut.find((/** @type {any} */ a) => a.name === 'F_KONV_STATUS');
		attribut.value = 'TO_PROCESS';
		node.modAttribute(attribut);
		await this.#NodeService.update(node);
		this.#Notification.success({
			title:   this.#$translate.instant('object.successfully-updated-title'),
			message: this.#$translate.instant('object.successfully-updated-message'),
		});
	}

	/**
	 * Rotates the image in preview file
	 */
	rotate() {
		const object = this.file?.url;
		switch (object.rotate) {
		case 0: {
			object.rotate = 90;
			break;
		}

		case 90: {
			object.rotate = 180;
			break;
		}

		case 180: {
			object.rotate = 270;
			break;
		}

		default: {
			object.rotate = 0;
		}
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.disabled) {
			this.jsonEditorOptions = changes.disabled.currentValue
				? this.jsonEditorDefaultOptions.readOnly : this.jsonEditorDefaultOptions.edit;

			if (
				changes.disabled.currentValue === false
				&& changes.disabled.previousValue === true
				&& this.form?.viewer_engine === 'html'
				&& this.file?.url.startsWith('<!doctype')
			) {
				this.#$timeout(() => {
					this.htmlPreviewInitializing = false;
				}, 1000);
			}
		}

		if (changes.form && this.form) {
			this.file = new FileUpload(this.#$injector, {
				size: this.form.getAttribute('F_SIZE')?.value,
				type: this.form.getAttribute('F_MIMETYPE')?.value,
				name: this.form.getAttribute('F_FILENAME')?.value,
			});
			this.file.uploaded = true;
			if (!this.form.create) {
				this.loadFile()
					.catch(console.error);
			}
		}
	}

	$onInit() {
		this.htmlPreviewInitializing = true;
		const files = this.kform?.files;
		if (files && this.form?.kid) {
			this.kid = this.form.kid;
			this.file = files[this.kid][0];
		}

		if (this.form?.kid && this.kform?.files?.[this.form.kid]) {
			this.#$scope.$watch(
				() => this.form?.kid && this.kform?.files[this.form.kid][0],
				(/** @type {any} */ newValue, /** @type {any} */ oldValue) => {
					if (newValue !== oldValue) {
						this.replacing = false;
					}
				},
			);
		}

		this.#$scope.$on('Form.submitted', () => {
			this.form?.formio?.kformForm.$setPristine();
			this.form?.formio?.kformForm.$setUntouched();
		});

		this.#$scope.$on('Form.change-tab', () => {
			if (this.file?.loaded) {
				this.file.loaded = 0;
				this.#$timeout(() => {
					if (this.file) {
						this.file.loaded = this.infos?.size ?? this.file.file.size;
					}
				});
			}
		});

		this.loading = false;
	}
}
